/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';

export const Container = styled.div`
display:flex;
flex-wrap:wrap;
flex-direction:column;
align-items:center;
justify-content:center;
`;

export const Title = styled.p`
font-family: Montserrat-Regular;
 
font-weight: 600;
letter-spacing: 2px;
font-size: 16px;
margin-bottom: 30px;
`;

export const Image = styled.img`
object-fit: contain;
margin-bottom: 30px;
`;

export const Description = styled.p`
font-family: Montserrat-Regular;
 
width: 65%;
text-align: center;
`;

export const Timer = styled.p`
font-family: Montserrat-Regular;
 
`;